import { useParams } from 'react-router'
import { allAvailableEventTypes } from 'src/consumer/constants'
import MentorEventTypes from 'src/supportPortal/components/common/mentor/eventTypes/MentorEventTypes'

const SUPPORT_DEFAULT_EVENT_PRICING = {
  countryId: 'row',
  currencyId: 'inr',
  price: 1000,
  discountedPrice: 1000,
  introductoryPrice: 1000,
}

export default function DoctorsEventTypes() {
  const { mentorSlug } = useParams()
  return (
    <MentorEventTypes
      mentorSlug={mentorSlug}
      fetchSingleMentorSignature={`/api/secure/cc/support/doctor/by-slug`}
      saveOneOnOnePlanApiSignature={`/api/secure/cc/support/1on1-custom-plan`}
      fetchMentorClinicAssociationsSignature={`/api/secure/cc/support/doctor/clinic-associations`}
      forDoctor
      forTherapist={false}
      newEventDefaults={{
        event: {
          type: allAvailableEventTypes.consultation,
          durationInMins: 15,
        },
        pricing: SUPPORT_DEFAULT_EVENT_PRICING,
        viewPriceCountry: 'IN',
      }}
    />
  )
}
